<template>
  <table class="table">
    <thead>
      <tr>
        <th :align="th.align || 'left'" :width="th.width" v-for="(th, index) in columns" :key="'th' + index">
          <slot>
            {{th.title}}
          </slot>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(tr, ind) in data" :key="'tr' + ind" @click="goto(tr)" :class="{ys:tr['win']>0&&isYs} ">
        <td :align="td.align" v-for="(td, inde) in columns"  :key="'td' + inde">
          <div :name="td.key" :row="tr" v-html="tr[td.key]" ></div>
        </td>
      </tr>

      <tr class="total-tr" v-if="showTotal" slot="total">
        <td  v-for="(th, indd) in columns" :key="'total-th' + indd"   >
          <slot :name="'total' + th.key" :total="getKeyTotal(th.key)">
            {{totalKey === th.key ? '合计' : getKeyTotal(th.rkey|| th.key)}}
          </slot>
        </td>
      </tr>

    </tbody>
  </table>
</template>

<script>
  export default {
    name: "v-table",
    props: {
      columns: {
        type: Array,
        default () {
          return [
            {
              title: '彩种类型',
              key: 'type',
              width: '40%',
              align: 'center'
            },
            {
              title: '注数',
              key: 'count',
              width: '30%',
              align: 'center'
            },
            {
              title: '金额',
              key: 'money',
              width: '30%',
              align: 'center'
            }
          ]
        }
      },
      showTotal: {
        type: Boolean,
        default: false
      },
      totalTarget: {
        type: String,
        default: ''
      },
      isYs: {
        type: Boolean,
        default: true
      },
      data: {
        type: Array,
        default () {
          return [
          ]
        }
      }
    },
    computed: {
      totalKey () {
        return this.totalTarget || this.columns[0].key;
      }
    },
    methods: {

        goto(item){
            this.$emit('goto',item);
        },

      getKeyTotal (key) {
        let total = 0;
        this.data.forEach(item => {
          total += parseFloat(item[key])
        });
        return total;
      }
    }
  }
</script>

<style scoped lang="less">
  table,th,td{
    border: 1px solid #d0d0d0;
    box-sizing: border-box;
  }
  .ys {background-color: #FF0}
  .table{
    width: 100%;
    font-size: 26px;
    line-height: 1.5;
    border-collapse: collapse;
    background-color: #fff;
    thead{
      background-color: #f0f0f0;
    }
    td,th{
      padding: 10px;
      text-align: center;
      vertical-align: middle;
    }
    .total-tr{
      background-color: #f0f0f0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/table/index.vue